import OverflowMenu from './OverflowMenu'
import Item from './Item'

let OverflowMenuComponent = OverflowMenu
OverflowMenuComponent.Item = Item

export default OverflowMenuComponent
